'use client';

import { useImport } from '../contexts/ImportContext';
import ImportProgressModal from './ImportProgressModal';

export default function GlobalImportModal() {
  const { importProgress, minimizeImport, closeImport } = useImport();

  const handleCancelImport = () => {
    const cancelFn = (window as unknown as { currentImportCancel?: () => void })
      .currentImportCancel;
    if (cancelFn) {
      cancelFn();
    }
  };

  return (
    <ImportProgressModal
      isOpen={importProgress.isOpen}
      isMinimized={importProgress.isMinimized}
      onClose={closeImport}
      onCancel={handleCancelImport}
      onMinimize={minimizeImport}
      totalFiles={importProgress.totalFiles}
      currentFile={importProgress.currentFile}
      importedCount={importProgress.importedCount}
      isComplete={importProgress.isComplete}
      isCancelling={importProgress.isCancelling}
      error={importProgress.error}
    />
  );
}
